import * as React from "react";
import { ControlLabel, FormGroup, HelpBlock } from "react-bootstrap";
import { ComponentEx, connect, translate } from "../../../controls/ComponentEx";
import Toggle from "../../../controls/Toggle";
import { setAnalytics } from "../actions/analytics.action";
import { HELP_ARTICLE, PRIVACY_POLICY } from "../constants";
class SettingsAnalytics extends ComponentEx {
    render() {
        const { t, analytics, userInfo } = this.props;
        return (React.createElement("form", null,
            React.createElement(FormGroup, { controlId: "analytics" },
                React.createElement(ControlLabel, null, t("Data & Privacy")),
                React.createElement(Toggle, { checked: analytics, disabled: !userInfo, onToggle: this.toggleAnalytics }, t("Allow this app to collect usage data to improve your experience")),
                React.createElement(HelpBlock, null,
                    t("Help us provide you with the best modding experience. With your permission, we will collect analytics information and send it to our team to help us improve quality and performance. This information is sent anonymously and will never be shared with a 3rd party."),
                    React.createElement("br", null),
                    React.createElement("br", null),
                    React.createElement("a", { href: HELP_ARTICLE, style: { marginLeft: "0.25rem" } }, t("More about the data we track")),
                    " ",
                    "|",
                    " ",
                    React.createElement("a", { href: PRIVACY_POLICY, style: { marginLeft: "0.25rem" } }, t("Privacy Policy"))))));
    }
    toggleAnalytics = () => {
        this.props.onSetAnalytics(!this.props.analytics);
    };
}
function mapStateToProps(state) {
    return {
        analytics: state.settings.analytics.enabled,
        userInfo: state.persistent.nexus.userInfo,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onSetAnalytics: (analytics) => {
            dispatch(setAnalytics(analytics));
        },
    };
}
export default translate(["common"])(connect(mapStateToProps, mapDispatchToProps)(SettingsAnalytics));
